import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { take } from 'rxjs';
import { ApiService } from '../../../shared/services/api.service';
import { ModalService } from '../../../shared/services/modal.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { ModalFooterComponent } from './../../../shared/modals/modal-footer/modal-footer.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [TranslateModule, PanelModule, ButtonModule],
})
export class FooterComponent {
  private _apiService = inject(ApiService);
  private _modalService = inject(ModalService);
  private _translateService = inject(TranslateService);
  private _utilsService = inject(UtilsService);

  year: number = new Date().getFullYear();

  modalFooter(modal: string): void {
    this._apiService
      .getTextCode({
        //item: modal + '_' + environment.platform + '_' + this._translateService.currentLang,
        item: modal + '_web_' + this._translateService.currentLang,
      })
      .pipe(take(1))
      .subscribe((textCode: any) => {
        if (!textCode?.functionalExceptions?.length && !textCode?.systemExceptions?.length) {
          const data = {
            title: 'footer.' + modal,
            body: textCode.text,
          };
          let width: string = '80%';
          if (this._utilsService.isApp()) {
            width = '100%';
          }
          this._modalService.showModal(ModalFooterComponent, data, width, false);
        }
      });
  }

  goToCigna(): void {
    window.open('https://cigna.es', '_blank');
  }
}
